import React, { Component } from 'react'
import { Grid, Col, Row } from 'react-flexbox-grid'
import PaidByOtherTextField from '../../../widgets/SubmitAClaim/PaidByOtherTextField'
import RBButton from '../../../controls/RBButton'
import RBDatePicker from '../../../controls/RBDatePicker'
import RBNumericTextBox from '../../../controls/RBNumericTextBox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import LinearProgress from '@material-ui/core/LinearProgress'
import moment from 'moment'
import { localize } from '../../../util/Localizer'
import { formatCurrency } from '../../../util/CurrencyFormatter'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { searchDentalProcCode, searchDetailToothCode } from '../../../redux/actions/submitDentalExpenseActions'
import TitledLabel from '../../../controls/TitledLabel'
import Loading from '../../Loading'
import NgrxUtil from '../../../util/NgrxUtils'
import { withStyles } from '@material-ui/core/styles'
import classnames from 'classnames'
import { Colors } from '../../../theme'

import {
  createEmptyDentalClaimExpense,
  createEmptyDentalClaimExpenseError,
  createToothSurfaces,
  validateToothCodeForDentalClaimExpense,
  validateDateForDentalClaimExpense,
  validateProcedureCodeForDentalClaimExpense,
  validateToothSurfacesForDentalClaimExpense,
  validateProcedureFeesForDentalClaimExpense,
  validateLaboratoryFeesForDentalClaimExpense,
  validateOtherChargesForDentalClaimExpense
} from './functions'

class ManageDentalExpense extends Component {
  constructor (props) {
    super(props)

    this.updateValues = this.updateValues.bind(this)
    this.onAddExpense = this.onAddExpense.bind(this)
    this.onCancel = this.onCancel.bind(this)
    this.validate = this.validate.bind(this)
    this.searchDentalProcedureCode = this.searchDentalProcedureCode.bind(this)
    this.showAdditionalFields = this.showAdditionalFields.bind(this)
    this.handleErrorOnInvalidProcCode = this.handleErrorOnInvalidProcCode.bind(this)
    this.onCheckChange = this.onCheckChange.bind(this)
    this.resetDetailedForm = this.resetDetailedForm.bind(this)
    this.checkSurfaceTotal = this.checkSurfaceTotal.bind(this)
    this.loadFromEdit = this.loadFromEdit.bind(this)

    this.state = {
      claimExpense: createEmptyDentalClaimExpense(this.props.hasCOB),
      claimExpenseError: createEmptyDentalClaimExpenseError(),
      toothSurfaces: createToothSurfaces(),
      showDetailedForm: false,
      showToothCode: false,
      showToothSurface: false,
      showLabFee: false,
      isDisabled: false,
      isChecked: false,
      toothCodeSearchState: {
        isValid: false,
        error: '',
        isSearching: false
      }
    }

    // TODO - this is refactored a bit to not use componentWillReceiveProps when editing an item as it
    // caused a new bug. This now gets rendered and unrendered from ClaimExpense to properly load things
    // but this static method has some logic that we need to look at, that's what the TODO is for. All Manage Expenses have this
    this.state = Object.assign(this.state, this.loadFromEdit(props, this.state))
  }

  loadFromEdit (nextProps, state) {
    // stringify the objects to do a string compare, not sure if this is the best way
    const localClaimState = JSON.stringify(state.claimExpense)
    const propClaimState = JSON.stringify(nextProps.claimExpense)
    if (Object.keys(nextProps.claimExpense).length > 0 &&
      nextProps.claimExpense.DentalInfo && state.claimExpense.DentalInfo &&
      state.claimExpense.DentalInfo.ProcedureCode !== nextProps.claimExpense.DentalInfo.ProcedureCode) {
      // basically here we need to clone the object so if we change locally we don't affect the array in claimExpenses.js
      const dentalInfo = { ...(JSON.parse(propClaimState).DentalInfo) }
      const claimExpense = JSON.parse(localClaimState)
      const claimExpenseNext = JSON.parse(propClaimState)

      // get the tooth surfaces
      const toothSurfaces = createToothSurfaces()
      /// this will disable the checkboxes as the assumption is if we are comign from an edit, it should alreadyd be valid and can't check more
      let isDisabled = true

      if (claimExpenseNext.DentalInfo.ToothSurface) {
        // loop through what is in the object and if it's a boolean set it to true. Reason we can do this is
        // when a checkbox is checked we store the string value as a string for example VOL means
        // checkbox V, O, L was selected
        // eslint-disable-next-line
        claimExpenseNext.DentalInfo.ToothSurface.split('').map(t => {
          toothSurfaces[t] = (typeof toothSurfaces[t] === 'boolean')
        })
      }

      // now set the state to update UI
      if ((claimExpense.DentalInfo.ProcedureCode)) {
        const updatedDentalInfo = Object.assign({ DentalInfo: { ...claimExpenseNext.DentalInfo, ProcedureCode: claimExpense.DentalInfo.ProcedureCode } })
        let updatedClaimExpense = Object.assign(claimExpenseNext, updatedDentalInfo)
        const statenew = {
          claimExpense: updatedClaimExpense,
          showDetailedForm: nextProps.claimIndx > -1,
          showToothCode: dentalInfo.ToothCode,
          showToothSurface: dentalInfo.ToothSurface && dentalInfo.ToothSurface.length > 0,
          showLabFee: claimExpenseNext.labAllowed !== '1',
          toothSurfaces,
          toothCodeSearchState: { isValid: true }
        }
        return statenew
      } else {
        const statenew = {
          claimExpense: claimExpenseNext,
          showDetailedForm: nextProps.claimIndx > -1,
          showToothCode: dentalInfo.ToothCode,
          showToothSurface: dentalInfo.ToothSurface && dentalInfo.ToothSurface.length > 0,
          showLabFee: claimExpenseNext.labAllowed !== '1',
          toothSurfaces,
          isDisabled,
          toothCodeSearchState: { isValid: true }
        }
        return statenew
      }
    }

    return null
  }

  onAddExpense () {
    if (this.validate()) {
      // stringify then parse the object so we get a new copy of the object so if this page does anything else with the state, it doesn't affect
      // who ever saves it

      const claim = { ...this.state.claimExpense }
      const dentalCode = this.props.dentalProcedureCodes

      // change out the strings to numbers since that is what API expects
      claim.DentalInfo.LaboratoryFees = Number(claim.DentalInfo.LaboratoryFees)
      claim.DentalInfo.ProcedureFees = Number(claim.DentalInfo.ProcedureFees)
      claim.DentalInfo.TotalCharges = Number(claim.DentalInfo.TotalCharges)

      claim.DentalInfo.treatmentSite = dentalCode.treatmentSite
      claim.DentalInfo.numSurfaces = dentalCode.numSurfaces
      claim.DentalInfo.labAllowed = dentalCode.labAllowed

      // notify the parent
      this.props.onAddExpense(JSON.parse(JSON.stringify(claim)))
      this.onCancel()
    }
  }

  onCancel () {
    this.props.onCancel()
  }

  validate (onlyToothCode = false) {
    const claimExpense = NgrxUtil.deepCopyObject(this.state.claimExpense)
    const claimExpenseError = NgrxUtil.deepCopyObject(this.state.claimExpenseError)
    const { showToothCode, showToothSurface, showLabFee } = { ...this.state }
    const { numSurfaces } = this.props.dentalProcedureCodes

    let isValid = true
    if (showToothCode) {
      if (!this.state.toothCodeSearchState.isValid && this.state.toothCodeSearchState.error) {
        isValid = false
        claimExpenseError.DentalInfo.ToothCode = this.state.toothCodeSearchState.error
      } else {
        isValid = validateToothCodeForDentalClaimExpense(claimExpense, claimExpenseError) && isValid
      }
    }

    if (!onlyToothCode) {
      isValid = validateDateForDentalClaimExpense(claimExpense, claimExpenseError) && isValid
      isValid = validateProcedureCodeForDentalClaimExpense(claimExpense, claimExpenseError) && isValid
      isValid = validateProcedureFeesForDentalClaimExpense(claimExpense, claimExpenseError) && isValid

      if (showToothSurface) {
        isValid = validateToothSurfacesForDentalClaimExpense(claimExpense, claimExpenseError, numSurfaces) && isValid
      }

      if (showLabFee) {
        isValid = validateLaboratoryFeesForDentalClaimExpense(claimExpense, claimExpenseError) && isValid
      }

      if (this.props.hasCOB) {
        isValid = validateOtherChargesForDentalClaimExpense(claimExpense, claimExpenseError) && isValid
      }
    }
    this.setState({ claimExpenseError })
    return isValid
  }

  updateValues (valueObj) {
    const claimExpense = { ...this.state.claimExpense }
    let updatedClaimExpense

    if (valueObj['ServiceDate']) {
      valueObj['ServiceDate'] = moment(valueObj['ServiceDate']).format('YYYY-MM-DD') // this needs to be in this format for the expenseCard
      updatedClaimExpense = Object.assign(claimExpense, valueObj)
    } else if (valueObj['COBAmount'] || valueObj['COBAmount'] === '') {
      const updatedcobField = Object.assign({ COBField: { ...claimExpense.COBField, ...valueObj } })
      updatedClaimExpense = Object.assign(claimExpense, updatedcobField)
    } else {
      const updatedDentalInfo = Object.assign({ DentalInfo: { ...claimExpense.DentalInfo, ...valueObj } })
      updatedClaimExpense = Object.assign(claimExpense, updatedDentalInfo)

      if (valueObj['ProcedureCode']) {
        if (valueObj['ProcedureCode'].length === 5) {
          const emptyClaim = createEmptyDentalClaimExpense()
          const updatedDentalInfo = Object.assign({ DentalInfo: { ...emptyClaim.DentalInfo, ...valueObj } })
          updatedClaimExpense = Object.assign(claimExpense, updatedDentalInfo)
          this.setState({ claimExpense: updatedClaimExpense }, () => this.searchDentalProcedureCode(valueObj['ProcedureCode']))
        } else {
          // reset the details for if it is showing
          if (this.state.showDetailedForm) {
            this.resetDetailedForm()
          }
        }
      }

      // set the tooth code
      if (valueObj['ToothCode']) {
        // clear the error if there is one
        if (this.state.claimExpenseError.DentalInfo.ToothCode && this.state.claimExpenseError.DentalInfo.ToothCode.length > 0) {
          const claimExpenseError = { ...this.state.claimExpenseError }
          claimExpenseError.DentalInfo.ToothCode = ''
          this.setState({ claimExpenseError })
        }

        // search if available
        if (valueObj['ToothCode'].length === 2) {
          if (!this.state.toothCodeSearchState.isSearching) {
            // set the tooth code searching state
            this.searchToothCode(valueObj['ToothCode'])
          }
        } else {
          // set the tooth code searching state
          this.setState({ toothCodeSearchState: { isValid: false, isSearching: false, error: '' } })
        }
      }
    }

    const totalCharges = (Number(updatedClaimExpense.DentalInfo.ProcedureFees) + Number(updatedClaimExpense.DentalInfo.LaboratoryFees) - Number(updatedClaimExpense.COBField && Number(updatedClaimExpense.COBField.COBAmount)))
    updatedClaimExpense.DentalInfo.TotalCharges = typeof totalCharges === 'number' ? (Math.round(totalCharges * 100) / 100).toFixed(2) : totalCharges.replace('null', '')
    this.setState({
      claimExpense: updatedClaimExpense
      // claimExpenseError: createEmptyDentalClaimExpenseError()
    })
  }

  onCheckChange (e) {
    const { claimExpense, toothSurfaces } = { ...this.state }
    const val = {}
    val[e.target.id] = e.target.checked
    Object.assign(toothSurfaces, val)
    const selectedToothSurfaces = Object.keys(toothSurfaces).map((e) => { if (toothSurfaces[e] === true) return e }).join('') // eslint-disable-line
    const updatedDentalInfo = Object.assign({ DentalInfo: { ...claimExpense.DentalInfo, ToothSurface: selectedToothSurfaces } })
    const updatedClaimExpense = Object.assign(claimExpense, updatedDentalInfo)

    this.setState({
      claimExpense: updatedClaimExpense,
      // claimExpenseError: createEmptyDentalClaimExpenseError(),
      toothSurfaces
    }, () => {
      this.checkSurfaceTotal()
    })
  }

  checkSurfaceTotal () {
    let allowedCheckboxes = this.props.dentalProcedureCodes.numSurfaces || 0
    const surfaces = this.state.toothSurfaces
    let counter = 0// Counter is the number of checked checkboxes//

    Object.keys(surfaces).forEach(key => {
      if (surfaces[key]) {
        counter++
      }
    })
    this.setState({
      isDisabled: counter === allowedCheckboxes
    }, () => {
      // remove error if allowed boxes are filled
      if (counter === allowedCheckboxes) {
        this.validate()
      }
    })
  }

  searchDentalProcedureCode (procedureCode) {
    this.props.searchDentalProcCode(procedureCode, this.showAdditionalFields, this.handleErrorOnInvalidProcCode)
  }

  searchToothCode (toothCode) {
    if (!this.state.toothCodeSearchState.isSearching) {
      this.setState({ toothCodeSearchState: { isSearching: true } })
      this.props.searchDetailToothCode(this.state.claimExpense.DentalInfo.ProcedureCode, toothCode,
        // handle success
        (result) => {
          this.setState({ toothCodeSearchState: { isValid: true, error: '', isSearching: false } })
        },
        // handle the error
        (result) => {
          this.setState({ toothCodeSearchState: { isValid: false, error: result.message, isSearching: false } })
          this.validate(true)
        })
    }
  }

  resetDetailedForm () {
    // reset all fields to their base states
    this.toothCode && this.toothCode.resetState()
    this.toothSurface && this.toothSurface.resetState()
    this.dentistFee && this.dentistFee.resetState()
    this.laboratoryFee && this.laboratoryFee.resetState()
    this.paidByOtherAmount && this.paidByOtherAmount.resetState()

    // get the values
    const claimExpense = { ...this.state.claimExpense }
    const { serviceDate, procedureCode, ...detailedForm } = { ...claimExpense }

    // clear out the fields on reset
    detailedForm.DentalInfo.LaboratoryFees = 0
    detailedForm.DentalInfo.ProcedureCode = this.procedureCode.state.value
    detailedForm.DentalInfo.ProcedureFees = 0
    detailedForm.DentalInfo.ToothCode = ''
    detailedForm.DentalInfo.ToothSurface = ''
    detailedForm.DentalInfo.TotalCharges = 0

    // update the claims object and set the state
    const updatedClaimExpense = Object.assign(claimExpense, detailedForm)
    this.setState({
      claimExpense: updatedClaimExpense,
      showDetailedForm: false,
      showToothCode: false,
      showToothSurface: false,
      showLabFee: false,
      toothSurfaces: createToothSurfaces()
    })
  }

  handleErrorOnInvalidProcCode () {
    this.resetDetailedForm()
    this.setState({
      showDetailedForm: false,
      showToothCode: false,
      showToothSurface: false,
      showLabFee: false
    })
  }

  showAdditionalFields () {
    const dentalCode = this.props.dentalProcedureCodes
    if (dentalCode) {
      let claimExpense = { ...this.state.claimExpense }
      claimExpense.labAllowed = dentalCode.labAllowed
      this.checkSurfaceTotal()
      this.resetDetailedForm()
      this.setState({
        showDetailedForm: true,
        showToothCode: dentalCode.treatmentSite === '1',
        showToothSurface: dentalCode.numSurfaces > 0,
        showLabFee: dentalCode.labAllowed !== '1',
        claimExpense
      })
    } else {
      this.resetDetailedForm()
      let claimExpense = { ...this.state.claimExpense }
      claimExpense.labAllowed = undefined
      this.setState({
        showDetailedForm: false,
        showToothCode: false,
        showToothSurface: false,
        showLabFee: false,
        claimExpense
      })
    }
  }

  render () {
    const { claimExpense, claimExpenseError, showDetailedForm, toothSurfaces, isDisabled } = { ...this.state }
    const { classes = {} } = this.props
    const vCheckboxDisabled = isDisabled && !toothSurfaces.V
    const oCheckboxDisabled = isDisabled && !toothSurfaces.O
    const lCheckboxDisabled = isDisabled && !toothSurfaces.L
    const dCheckboxDisabled = isDisabled && !toothSurfaces.D
    const mCheckboxDisabled = isDisabled && !toothSurfaces.M
    const iCheckboxDisabled = isDisabled && !toothSurfaces.I

    let addButtonLabel = showDetailedForm ? localize('pages.SubmitAClaim.Expenses.AddExpenseButton') : localize('common.saveUpdates')
    let formTitle = localize('pages.SubmitAClaim.Expenses.AddExpenseFormTitle')
    if (this.props.claimIndx >= 0) {
      addButtonLabel = localize('common.saveUpdates')
      formTitle = localize('pages.SubmitAClaim.Expenses.EditExpenseFormTitle')
    }
    const isLoading = this.props.dentalProcedureCodeLoading
    let errorStyle = {
      position: 'relative',
      bottom: '2px',
      fontSize: '12px',
      lineHeight: '12px',
      color: Colors.Palette.errorColor,
      paddingLeft: '9px'
    }
    return (
      <Grid fluid style={{ overflowY: 'scroll', height: '100vh' }}>
        <Row start='xs'>
          <Col xs={12}>
            <h3 className='marginBottom0px'>{formTitle}</h3>
            <p className='titledLabelTitle'>{localize('error.account.activateAccount.20001018')}</p>
          </Col>
        </Row>
        <br />
        <Row start='xs'>
          <Col xs={12}>
            <RBDatePicker ref={(comp) => { this.serviceDate = comp }}
              id='ServiceDate'
              label={localize('pages.SubmitAClaim.Expenses.ServiceDate')}
              errorText={claimExpenseError.ServiceDate}
              fullWidth
              pickerProps={{
                autoOk: true,
                maxDate: moment(),
                value: claimExpense.ServiceDate || null,
                onChange: value => this.updateValues({ ServiceDate: value })
              }}
              onBlur={claimExpenseError.ServiceDate ? () => this.validate() : null}
            />
          </Col>
        </Row>
        <Row start='xs'>
          <Col xs={12}>
            <br />
            <RBNumericTextBox ref={(comp) => { this.procedureCode = comp }}
              floatingLabelFixed
              tooltip={localize('pages.SubmitAClaim.Expenses.Dental.tooltip')}
              textLabel={localize('pages.SubmitAClaim.Expenses.Dental.ProcedureCode')}
              fullWidth
              type='tel'
              format='#####'
              id='ProcedureCode'
              autoComplete='off'
              onValueChange={this.updateValues}
              error={(this.props.dentalProcedureCodeError && this.props.dentalProcedureCodeError.message) ||
                (claimExpenseError.DentalInfo && claimExpenseError.DentalInfo.ProcedureCode)}
              value={claimExpense.DentalInfo.ProcedureCode}
            />
          </Col>
        </Row>

        {/* show the details part */}
        {isLoading && <Loading />}
        {!isLoading && showDetailedForm && this.state.showToothCode &&
          <Row start='xs'>
            <Col xs={12}>
              <RBNumericTextBox ref={(comp) => { this.toothCode = comp }}
                floatingLabelFixed
                textLabel={localize('pages.SubmitAClaim.Expenses.Dental.ToothCode')}
                id='ToothCode'
                format='##'
                autoComplete='off'
                onValueChange={this.updateValues}
                error={claimExpenseError.DentalInfo.ToothCode}
                value={claimExpense.DentalInfo.ToothCode}
                decimalScale={0}
                onBlur={claimExpenseError.DentalInfo.ToothCode ? () => this.validate() : null}
              />
            </Col>
          </Row>
        }
        {/* show the progress when searching toothcode */}
        {(this.state.toothCodeSearchState.isSearching ? <LinearProgress color='primary' style={{ position: 'relative', bottom: 12 }} /> : null)}
        {!isLoading && showDetailedForm && this.state.showToothSurface &&
          <Row start='xs'>
            <Col xs>
              <Row start='xs'>
                <Col xs={12}>
                  <TitledLabel title='pages.SubmitAClaim.Expenses.Dental.ToothSurfaces' value=' ' />
                </Col>
              </Row>
              <Row start='xs'>
                <Col xs={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        ref={(v) => { this.toothV = v }}
                        id='V'
                        checked={toothSurfaces.V}
                        onChange={this.onCheckChange}
                        value={'true'}
                        color='primary'
                        disabled={vCheckboxDisabled}

                      />
                    }
                    className='checkLabel'
                    label='V(B)'
                  />
                </Col>
                <Col xs={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        ref={(o) => { this.toothO = o }}
                        id='O'
                        checked={toothSurfaces.O}
                        onChange={this.onCheckChange}
                        value={'true'}
                        color='primary'
                        disabled={oCheckboxDisabled}
                      />
                    }
                    className='checkLabel'
                    label='O'
                  />
                </Col>
                <Col xs={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        ref={(l) => { this.toothL = l }}
                        id='L'
                        checked={toothSurfaces.L}
                        onChange={this.onCheckChange}
                        value={'true'}
                        color='primary'
                        disabled={lCheckboxDisabled}
                      />
                    }
                    className='checkLabel'
                    label='L'
                  />
                </Col>
                <Col xs={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        ref={(d) => { this.toothD = d }}
                        id='D'
                        checked={toothSurfaces.D}
                        onChange={this.onCheckChange}
                        value={'true'}
                        color='primary'
                        disabled={dCheckboxDisabled}
                      />
                    }
                    className='checkLabel'
                    label='D'
                  />
                </Col>
                <Col xs={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        ref={(m) => { this.toothM = m }}
                        id='M'
                        checked={toothSurfaces.M}
                        onChange={this.onCheckChange}
                        value={'true'}
                        color='primary'
                        disabled={mCheckboxDisabled}
                      />
                    }
                    className='checkLabel'
                    label='M'
                  />
                </Col>
                <Col xs={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        ref={(i) => { this.toothI = i }}
                        checked={toothSurfaces.I}
                        onChange={this.onCheckChange}
                        value={'true'}
                        color='primary'
                        id='I'
                        disabled={iCheckboxDisabled}
                      />
                    }
                    className='checkLabel'
                    label='I'
                  />
                </Col>
              </Row>
              <Row>
                <p style={errorStyle}>
                  {claimExpenseError.DentalInfo.ToothSurface ? `${claimExpenseError.DentalInfo.ToothSurface} ${this.props.dentalProcedureCodes.numSurfaces}` : null}
                </p>
              </Row>
            </Col>
          </Row>
        }
        {!isLoading && showDetailedForm &&
          <Row start='xs'>
            <Col xs={12}>
              <PaidByOtherTextField ref={(comp) => { this.dentistFee = comp }}
                textLabel={localize('pages.SubmitAClaim.Expenses.Dental.DentistsFee')}
                // className='textBoxPaybyOther'
                floatingLabelFixed
                fullWidth
                id='ProcedureFees'
                autoComplete='off'
                onValueChange={this.updateValues}
                error={claimExpenseError.DentalInfo.ProcedureFees}
                value={claimExpense.DentalInfo.ProcedureFees}
                onBlur={claimExpenseError.DentalInfo.ProcedureFees ? () => this.validate() : null}
                limit={10000}
              />
            </Col>
          </Row>
        }
        {!isLoading && showDetailedForm && this.state.showLabFee &&
          <Row start='xs'>
            <Col xs={12}>
              <PaidByOtherTextField ref={(comp) => { this.laboratoryFee = comp }}
                floatingLabelFixed
                textLabel={localize('pages.SubmitAClaim.Expenses.Dental.LabCharge')}
                // className='textBoxPaybyOther'
                fullWidth
                id='LaboratoryFees'
                autoComplete='off'
                onValueChange={this.updateValues}
                error={claimExpenseError.DentalInfo.LaboratoryFees}
                value={claimExpense.DentalInfo.LaboratoryFees}
                onBlur={claimExpenseError.DentalInfo.LaboratoryFees ? () => this.validate() : null}
              />
            </Col>
          </Row>
        }
        {!isLoading && showDetailedForm && this.props.hasCOB &&
          <Row start='xs'>
            <Col xs={12}>
              <PaidByOtherTextField ref={(comp) => { this.paidByOtherAmount = comp }}
                floatingLabelFixed
                textLabel={localize('pages.SubmitAClaim.Expenses.AmountReceivedFromAllOtherInsurance')}
                // className='textBoxPaybyOther'
                fullWidth
                id='COBAmount'
                autoComplete='off'
                onValueChange={this.updateValues}
                error={claimExpenseError.COBField.COBAmount}
                value={claimExpense.COBField.COBAmount.toString()}
                labelStyles={{ width: '125%' }}
                onBlur={claimExpenseError.COBField.COBAmount ? () => this.validate() : null}
                limit={10000}
              />
            </Col>
          </Row>
        }
        {!isLoading && showDetailedForm && this.state.showLabFee &&
          <Row start='xs'>
            <Col xs={12}>
              <PaidByOtherTextField
                textLabel={localize('pages.SubmitAClaim.Expenses.TotalChargesLabel')}
                floatingLabelFixed
                // className='textBoxPaybyOther'
                fullWidth
                id='TotalCharges'
                autoComplete='off'
                disabled
                value={formatCurrency(claimExpense.DentalInfo.TotalCharges)}
                limit={10000}
              />
            </Col>
          </Row>
        }
        <Row start='xs'>
          <Col xs={12} sm={6}>
            <RBButton fullWidth label={localize('common.cancel')} variant='outlined' onClick={this.onCancel} className={classnames(classes.margin)} />
          </Col>
          <Col xs={12} sm={6}>
            {!isLoading && showDetailedForm && <RBButton fullWidth label={addButtonLabel} variant='contained' primary onClick={this.onAddExpense} className={classnames(classes.margin)} />}
            {isLoading || !showDetailedForm ? <RBButton fullWidth label={localize('pages.SubmitAClaim.Expenses.AddExpenseButton')} variant='contained' primary onClick={this.onAddExpense} className={classnames(classes.margin)} disabled /> : null}
          </Col>
        </Row>
      </Grid>
    )
  }
}

function mapStateToProps (state, ownProps) {
  return {
    dentalProcedureCodeLoading: state.SubmitDentalExpenseReducer.dentalProcedureCodeLoading,
    dentalProcedureCodes: state.SubmitDentalExpenseReducer.dentalProcedureCode,
    dentalProcedureCodeError: state.SubmitDentalExpenseReducer.dentalProcedureCodeError
  }
}
const ConnectedManageDentalExpense = connect(mapStateToProps, { searchDentalProcCode, searchDetailToothCode })(injectIntl(ManageDentalExpense))

const Styles = {
  margin: {
    marginTop: 10
  }
}

export default withStyles(Styles)(ConnectedManageDentalExpense)



// WEBPACK FOOTER //
// ./src/widgets/SubmitAClaim/ManageDentalExpense/index.js